import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { ConfigService } from '@core/services';
import { AccountService } from '../services/account/account.service';

export const jwtInterceptor: HttpInterceptorFn = (req, next) => {
  const account = inject(AccountService);
  const configService = inject(ConfigService);
  const isLoggedIn = !!account.accessToken;

  if (isLoggedIn) {
    let authToken = `Bearer ${account.accessToken}`;

    if (configService.staticToken) {
      authToken = `Token ${configService.staticToken}`;
    }

    req = req.clone({
      setHeaders: { Authorization: authToken },
    });
  }

  return next(req);
};
